/**
 * When true, ArrowLeft/ArrowRight are safe for global shell shortcuts (toggle sidebars).
 * When false, focus is in a control that typically uses horizontal arrows (text entry, lists, etc.).
 */
export function canShellArrowKeyToggleSidebars(): boolean {
  const el = document.activeElement
  if (!el || !(el instanceof Element)) return true

  if (el.closest('[data-shell-arrow-passthrough]')) return false

  if (el instanceof HTMLInputElement) {
    const t = el.type
    // Only types that do not use ←/→ for value / caret / group navigation
    if (
      t === 'button' ||
      t === 'checkbox' ||
      t === 'color' ||
      t === 'file' ||
      t === 'hidden' ||
      t === 'image' ||
      t === 'reset' ||
      t === 'submit'
    ) {
      return true
    }
    return false
  }

  if (el instanceof HTMLTextAreaElement) return false
  if (el instanceof HTMLSelectElement) return false
  if (el instanceof HTMLElement && el.isContentEditable) return false

  const r = el.getAttribute('role')
  if (
    r === 'textbox' ||
    r === 'searchbox' ||
    r === 'combobox' ||
    r === 'listbox' ||
    r === 'option' ||
    r === 'menu' ||
    r === 'menuitem' ||
    r === 'slider' ||
    r === 'spinbutton' ||
    r === 'radiogroup'
  ) {
    return false
  }

  return true
}
